import authenticationReducer from "auth/store/authenticationSlice";
import { combineReducers } from "redux";
import { breadcrumbSlice } from "../breadcrumb/store";
import { asyncCounterSlice } from "./asyncCounterSlice";
import { closeConfirmationStatusSlice } from "./closeConfirmationStatusSlice";
import { messagesSlice } from "./messagesSlice";

export const commonReducer = combineReducers({
  breadcrumb: breadcrumbSlice.reducer,
  messages: messagesSlice.reducer,
  asyncCounter: asyncCounterSlice.reducer,
  closeConfirmationStatus: closeConfirmationStatusSlice.reducer,
  authentication: authenticationReducer,
});
